import { inject, Service } from "@angular/core";
import { filter } from "rxjs";

import {
  DataEntryDetails,
  ForecastedValuesMetric,
  ForecastedValuesMetricResponse,
  MainResponseModel,
  MetricsDetailModelType,
} from "../models";
import { MainService } from "./main-service";

@Service()
export class ForecastedValuesApiService {
  private _mainService = inject(MainService);

  public getByKpiId(kpiId: number) {
    return this._mainService
      .sendRequest<MainResponseModel<DataEntryDetails>>({
        method: "GET",
        url: `forecasted-values/getByKpiId/${kpiId}`,
      })
      .pipe(filter((res) => !res.inError));
  }

  public getMetricById(metricId: number) {
    return this._mainService
      .sendRequest<MainResponseModel<MetricsDetailModelType>>({
        method: "GET",
        url: `forecasted-values/getMetricById/${metricId}`,
      })
      .pipe(filter((res) => !res.inError));
  }

  public getMetricValues(metricId: number) {
    return this._mainService
      .sendRequest<MainResponseModel<ForecastedValuesMetricResponse[]>>({
        method: "GET",
        url: `forecasted-values/getMetricValues/${metricId}`,
      })
      .pipe(filter((res) => !res.inError));
  }

  public addMetricValue(model: ForecastedValuesMetric) {
    return this._mainService
      .sendRequest<MainResponseModel<number>>({
        method: "POST",
        url: `forecasted-values/addMetricValue`,
        data: model,
      })
      .pipe(filter((res) => !res.inError));
  }

  public updateMetricValue(id: number, value: number) {
    return this._mainService
      .sendRequest<MainResponseModel>({
        method: "POST",
        url: `forecasted-values/updateMetricValue/${id}`,
        data: {
          value,
        },
      })
      .pipe(filter((res) => !res.inError));
  }

  public deleteMetricValue(id: number) {
    return this._mainService
      .sendRequest<MainResponseModel>({
        method: "DELETE",
        url: `forecasted-values/deleteMetricValue/${id}`,
      })
      .pipe(filter((res) => !res.inError));
  }

  public updateForecastedValue(model: DataEntryDetails) {
    return this._mainService
      .sendRequest<MainResponseModel>({
        method: "POST",
        url: `forecasted-values/updateValue`,
        data: model,
      })
      .pipe(filter((res) => !res.inError));
  }

  public getKpiValues(kpiId: number) {
    return this._mainService
      .sendRequest<MainResponseModel<ForecastedValuesMetricResponse[]>>({
        method: "GET",
        url: `forecasted-values/getKpiValues/${kpiId}`,
      })
      .pipe(filter((res) => !res.inError));
  }
}
